<template>
  <div style='width: 100%;'>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <div v-else-if='statusGeral === ""'>
      <div class="rf-mask-titulo" style="margin-top: -10px; margin-left: -15px; border-radius: 0; margin-right: -15px; border-top-right-radius: 5px;" v-if='cpntFields.length === 0'>
        <template>
          <i aria-hidden="true" class="fa fa-angle-double-right"></i>
          Dados da Licença de Uso {{ $store.state.token.clu }}
        </template>
      </div>
      <div style='width: 720px; padding-top: 25px;' v-if='time !== "" && Object.keys(formulario1.field).length >= 1'>
        <RF-Formulario :data-time='time'
          :cpntTime='time'
          :cpntId='formulario1.id' 
          :cpntStatus='""'
          :cpntField='formulario1.field'
          :cpntUltAlt='formulario1.ultAlt'
          :cpntButtons='formulario1.buttons'
          :cpntTabIndexFieldGeral='formulario1.tabIndexFieldGeral'
          :cpntTabIndexButtonGeral='formulario1.tabIndexButtonGeral'

          @onLimpaFormularioFocus='formulario2.focus = ""'
          :ref='formulario1.id'
        ></RF-Formulario>
      </div>

      <div style='width: 720px; padding-right: 20px; margin-bottom: 30px;' v-if='statusGeral === "" && Object.keys(tabelaCnae).length >= 2 && time !== ""' v-show='tabelaCnae.mostrar'>
        <div style='padding-bottom: 10px;'>
          <RF-Button 
            :cpntId='tabelaCnae.button.id' 
            :cpntStatus='tabelaCnae.button.status' 
            :cpntTexto='tabelaCnae.button.texto' 
            :cpntClass='tabelaCnae.button.class' 

            @onClickButton='tabelaCnae.button.onClick()'
          ></RF-Button>

          <RF-Dialog v-if='tabelaCnae.mostraForm' 
            :cpntStatus='tabelaCnae.autoComplite.status'
            :cpntRegistro='[]'
            :cpntLargura='"400px"'
            :cpntTitulo='"Buscar CNAE"'

            :cpntOnFecharDialog='tabelaCnae.button.onAbrirFecharFormulario'>
            <template slot='conteudo'>
              <div class="rf-meu-cad-auto-complite">
                <RF-Input-Complite
                  :class='"rf-field-tamanho-" + (tabelaCnae.autoComplite.hasOwnProperty("tamanho") ? tabelaCnae.autoComplite.tamanho : 0)'
                  :cpntStatus='tabelaCnae.autoComplite.status'
                  :cpntId='tabelaCnae.autoComplite.id'
                  :cpntNome='tabelaCnae.autoComplite.nome'
                  :cpntValue='tabelaCnae.autoComplite.value'
                  :cpntMensagem='tabelaCnae.autoComplite.mensagem'
                  :cpntMensagemTipo='tabelaCnae.autoComplite.mensagemTipo'
                  :cpntDisabled='tabelaCnae.autoComplite.disabled'
                  :cpntMostrar='tabelaCnae.autoComplite.mostrar'
                  :cpntExplica='tabelaCnae.autoComplite.explica'

                  :cpntPlaceholder='tabelaCnae.autoComplite.placeholder'
                  :cpntValueRef='tabelaCnae.autoComplite.valueRef'
                  :cpntRouter='tabelaCnae.autoComplite.router'
                  :cpntMethod='tabelaCnae.autoComplite.method'
                  :cpntField='tabelaCnae.autoComplite.field'
                  :cpntWhere='tabelaCnae.autoComplite.where'
                  :cpntAddButForm='tabelaCnae.autoComplite.addButForm'
                  :cpntKeyMostra='tabelaCnae.autoComplite.keyMostra'

                  :cpntOnChange='tabelaCnae.autoComplite.onChange'
                  :cpntOnRealizaBusca='tabelaCnae.autoComplite.onRealizaBusca'

                  :ref='tabelaCnae.autoComplite.id'
                ></RF-Input-Complite>
              </div>
            </template>
          </RF-Dialog>
        </div>

        <RF-Tabela :data-time='time'
          :cpntTime='time'
          :cpntId='tabelaCnae.id'
          :cpntStatus='tabelaCnae.status'
          :cpntButtonImprimir='tabelaCnae.acoes.btImprimir'
          :cpntButtonAtualizar='tabelaCnae.acoes.btAtualizar'
          :cpntFraseTop='tabelaCnae.fraseTop'
          :cpntColuna='tabelaCnae.coluna'
          :cpntLinha='tabelaCnae.linha'
          :cpntCountAll='tabelaCnae.countAll'
          :cpntColspan='tabelaCnae.colspan'
          :cpntButtonsAcoes='tabelaCnae.acoes.buttons'
          :cpntMper='tabelaCnae.mper'
          :cpntPagina='tabelaCnae.pagina'
          :cpntCheckboxEditar='tabelaCnae.checkboxEditar'
          :cpntFieldsEditar='tabelaCnae.acoes.fields'

          :cpntOnCheckboxAtualiza='onCheckboxAtualizaCnae'
          :ref='tabelaCnae.id'
        ></RF-Tabela>
      </div> 

      <div style='width: 720px; padding-right: 20px; margin-bottom: 30px;' v-if='statusGeral === "" && Object.keys(tabelaAtiv).length >= 2 && time !== ""' v-show='tabelaAtiv.mostrar'>
        <div style='padding-bottom: 10px;'>
          <RF-Button 
            :cpntId='tabelaAtiv.button.id' 
            :cpntStatus='tabelaAtiv.button.status' 
            :cpntTexto='tabelaAtiv.button.texto' 
            :cpntClass='tabelaAtiv.button.class' 

            @onClickButton='tabelaAtiv.button.onClick()'
          ></RF-Button>

          <RF-Dialog v-if='tabelaAtiv.mostraForm'
            :cpntStatus='tabelaAtiv.autoComplite.status'
            :cpntRegistro='[]'
            :cpntLargura='"400px"'
            :cpntTitulo='"Buscar Atividade"'

            :cpntOnFecharDialog='tabelaAtiv.button.onAbrirFecharFormulario'>
            <template slot='conteudo'>
              <div class="rf-meu-cad-auto-complite">
                <RF-Input-Complite
                  :class='"rf-field-tamanho-" + (tabelaAtiv.autoComplite.hasOwnProperty("tamanho") ? tabelaAtiv.autoComplite.tamanho : 0)'
                  :cpntStatus='tabelaAtiv.autoComplite.status'
                  :cpntId='tabelaAtiv.autoComplite.id'
                  :cpntNome='tabelaAtiv.autoComplite.nome'
                  :cpntValue='tabelaAtiv.autoComplite.value'
                  :cpntMensagem='tabelaAtiv.autoComplite.mensagem'
                  :cpntMensagemTipo='tabelaAtiv.autoComplite.mensagemTipo'
                  :cpntDisabled='tabelaAtiv.autoComplite.disabled'
                  :cpntMostrar='tabelaAtiv.autoComplite.mostrar'
                  :cpntExplica='tabelaAtiv.autoComplite.explica'

                  :cpntPlaceholder='tabelaAtiv.autoComplite.placeholder'
                  :cpntValueRef='tabelaAtiv.autoComplite.valueRef'
                  :cpntRouter='tabelaAtiv.autoComplite.router'
                  :cpntMethod='tabelaAtiv.autoComplite.method'
                  :cpntField='tabelaAtiv.autoComplite.field'
                  :cpntWhere='tabelaAtiv.autoComplite.where'
                  :cpntAddButForm='tabelaAtiv.autoComplite.addButForm'
                  :cpntKeyMostra='tabelaAtiv.autoComplite.keyMostra'

                  :cpntOnChange='tabelaAtiv.autoComplite.onChange'
                  :cpntOnRealizaBusca='tabelaAtiv.autoComplite.onRealizaBusca'

                  :ref='tabelaAtiv.autoComplite.id'
                ></RF-Input-Complite>
              </div>
            </template>
          </RF-Dialog>
        </div>

        <RF-Tabela :data-time='time'
          :cpntTime='time'
          :cpntId='tabelaAtiv.id'
          :cpntStatus='tabelaAtiv.status'
          :cpntButtonImprimir='tabelaAtiv.acoes.btImprimir'
          :cpntButtonAtualizar='tabelaAtiv.acoes.btAtualizar'
          :cpntFraseTop='tabelaAtiv.fraseTop'
          :cpntColuna='tabelaAtiv.coluna'
          :cpntLinha='tabelaAtiv.linha'
          :cpntCountAll='tabelaAtiv.countAll'
          :cpntColspan='tabelaAtiv.colspan'
          :cpntButtonsAcoes='tabelaAtiv.acoes.buttons'
          :cpntMper='tabelaAtiv.mper'
          :cpntPagina='tabelaAtiv.pagina'
          :cpntCheckboxEditar='tabelaAtiv.checkboxEditar'
          :cpntFieldsEditar='tabelaAtiv.acoes.fields'

          :cpntOnCheckboxAtualiza='onCheckboxAtualizaAtividade'
          :ref='tabelaAtiv.id'
        ></RF-Tabela>
      </div>

      <div style='width: 720px;' v-if='time !== "" && Object.keys(formulario2.field).length >= 1'>
        <RF-Formulario :data-time='time'
          :cpntTime='time'
          :cpntId='formulario2.id' 
          :cpntStatus='""'
          :cpntField='formulario2.field'
          :cpntUltAlt='formulario2.ultAlt'
          :cpntButtons='formulario2.buttons'
          :cpntTabIndexFieldGeral='formulario2.tabIndexFieldGeral'
          :cpntTabIndexButtonGeral='formulario2.tabIndexButtonGeral'

          @onLimpaFormularioFocus='formulario2.focus = ""'
          :ref='formulario2.id'
        ></RF-Formulario>
      </div>
      
      <div class='rf-button-form' v-if='statusGeral === ""'>
        <template v-for='(button, index) in buttons'>
          <RF-Button :key="index"
            :cpntId='button.id' 
            :cpntStatus='button.status' 
            :cpntTexto='button.texto' 
            :cpntClass='button.class' 
            :cpntTabIndex='button.tabIndex' 

            @onClickButton='button.onClick()'
          ></RF-Button>
        </template>
      </div>

      <RF-Verifica-Campo-Update v-if="Object.keys(buscaCNPJ).length >= 1"
        :cpntTipo="'contato'"
        :cpntDadosApi="buscaCNPJ.dados"
        :cpntDadosForm="buscaCNPJ.dadosForm"
        :cpntCampos="buscaCNPJ.campos"

        :cpntOnFecharFormulario="buscaCNPJ.fecharFormulario"
      ></RF-Verifica-Campo-Update>
    </div>
  </div>
</template>

<style scoped>
  .rf-button-form {
    text-align: center;
    width: 720px; 
    margin-bottom: 30px;
  }
</style>

<style>
  #form-inserir-cnae > div > .rf-form > div {
    width: 300px;
  }
    #form-inserir-cnae > div > .rf-form > div > button {
      margin: 5px;
    }
  .tab-form-config-cadastro-1-tab-cnae-td-cnae {
    width: 90px;
  } 
 .rf-web-mask-conteudo > div > .dropdown-menu {
    position: fixed;
 }

 .rf-meu-cad-auto-complite {
    text-align: center;
    padding-top: 20px;
 }
   div.rf-meu-cad-auto-complite > div {
      margin-bottom: 0px;
    }
      div.rf-meu-cad-auto-complite > div > ul.dropdown-menu {
        position: fixed !important;
      }

  div > .rf-form > .rf-field-busca_api ~ .rf-field-razao {
    width: 425px;
  }
</style>

<script>
  import { SESSAO_ATUALIZAR_VUEX } from '@/assets/js/Sessao.js'

  export default {
    props: {
      cpntFields: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      },
      cpntNomeButton: {
        required: false,
        default: function () {
          return 'Atualizar Meu Cadastro'
        }
      },
      cpntApiValid: {
        required: false,
        default: function () {
          return {}
        }
      },
      cpntFecharCadastro: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'RF-Input-Complite': () => import('@/components/rf-geral/input-complite/RF-Input-Complite.vue'),
      'RF-Verifica-Campo-Update': () => import('@/RF-Verifica-Campo-Update.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario1: {},
        formulario2: {},
        tabelaCnae: {},
        tabelaAtiv: {},
        checkbox: {},
        focus: '',
        buttons: {},
        buscaCNPJ: {},

        optionsEstado: [],
        optionsRegimeEspTrib: [],
        optionsIncentivador: [],
        optionsOptanteSimples: [],

        selectedCnae: [],
        selectedAtiv: []
      }
    },
    mounted: function () {
      this.iniciar()
    },
    methods: {
      iniciar: function () {
        var self = this

        // SETA O STATUS
        self.statusGeral = 'carregando'

        // RESETA TODOS OS CAMPOS
        self.formulario1 = {}
        self.formulario2 = {}
        self.tabelaCnae = {}
        self.tabelaAtiv = {}
        self.checkbox = {}
        self.optionsEstado = []
        self.optionsRegimeEspTrib = []
        self.optionsIncentivador = []
        self.optionsOptanteSimples = []
        self.focus = ''
        self.buttons = {}

        self.selectedCnae = []
        self.selectedAtiv = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // if (self.$route.params.hasOwnProperty('mensagem')) {
        //   self.$store.state.msgWarn(self.$route.params.mensagem.texto, self.$route.params.mensagem.tipo)
        // }

        var queryGet = { type: 'list', field: { uf: null, estado: null }, limit: { row: 0, qty: 1000 } }
        // COMUNICA COM A API
        self.$store.state.comunicaAPI('/referencia/cep-estado/get/', 'GET', queryGet, function (apiSuccess) {
          // SETA OS VALORES RECEBIDOS DA API
          self.optionsEstado = apiSuccess.data

          self.buscaInformacoesNFSe()
        }, function (apiError) {
          // SETA O STATUS
          self.statusGeral = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      buscaInformacoesNFSe: function () {
        if (this.$store.state.token.clu_pcc.indexOf(25) !== -1) {
          var self = this

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/referencia/ser-inc-cultural/get', 'GET', null, function (apiSuccess) {
            // SETA OS OPTIONS RECEBIDOS
            self.optionsIncentivador = apiSuccess.data

            self.$store.state.comunicaAPI('/referencia/ser-opt-sim-nacional/get', 'GET', null, function (apiSuccess) {
              // SETA OS OPTIONS RECEBIDOS
              self.optionsOptanteSimples = apiSuccess.data

              self.$store.state.comunicaAPI('/referencia/ser-reg-esp-tributacao/get', 'GET', null, function (apiSuccess) {
                // SETA OS OPTIONS RECEBIDOS
                self.optionsRegimeEspTrib = apiSuccess.data

                // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
                self.iniciaFormulario()
              }, function (apiError) {
                // SETA O STATUS
                self.statusGeral = apiError

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            }, function (apiError) {
              // SETA O STATUS
              self.statusGeral = apiError

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        } else {
          // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
          this.iniciaFormulario()
        }
      },
      iniciaFormulario: function () {
        var self = this

        var contField = 0

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario1 = {
          status: '',
          id: 'form-config-cadastro-1',
          focus: '',
          field: {},
          idProduto: '',
          tabIndexFieldGeral: 10001
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.formulario1.field.cnpj = {
          tipo: 'input',
          tamanho: 2,
          nome: 'CNPJ',
          mask: 'cnpj',
          apiEnv: 'cnpj',
          apiRec: 'cnpj',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field.busca_api = {
          tamanho: 2,
          tipoButton: 'icone',
          tipo: 'button',
          icone: {
            tipo: 'busca-ws'
          },
          disabled: true,
          title: 'Buscar',
          class: [ 'btn', 'btn-warning', 'btn-sm' ],
          onClick: function () {
            self.meuCadastroOnBuscaCNPJ()
          }
        }

        self.formulario1.field.razao = {
          tipo: 'input',
          tamanho: 1,
          nome: 'Razão Social',
          apiEnv: 'nome',
          apiRec: 'nome',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field['separador-' + contField] = { tipo: 'clear' }
        contField++

        self.formulario1.field.ie = {
          tipo: 'input',
          tamanho: 2,
          nome: 'Insc. Estadual',
          apiEnv: 'ie',
          apiRec: 'ie',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }

        self.formulario1.field.im = {
          tipo: 'input',
          tamanho: 2,
          nome: 'Insc. Municipal',
          apiEnv: 'im',
          apiRec: 'im',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }

        self.formulario1.field.cmc = {
          tipo: 'input',
          tamanho: 2,
          nome: 'CMC',
          apiEnv: 'cmc',
          apiRec: 'cmc',
          explica: { mensagem: 'Cadastro Municipal do Contribuinte<br><br>O Cadastro Municipal de Contribuintes de Tributos Mobiliários é o cadastro das pessoas físicas e jurídicas que exercem atividades no município sujeitas ao pagamento do Imposto sobre Serviços de Qualquer Natureza - ISSQN ou das Taxas Mobiliárias.' },
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field['separador-' + contField] = { tipo: 'clear' }
        contField++

        self.formulario1.field.telefone = {
          tipo: 'input',
          tamanho: 2,
          nome: 'Telefone',
          apiEnv: 'telefone',
          apiRec: 'telefone',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }

        self.formulario1.field.email = {
          tipo: 'input',
          tamanho: 1,
          nome: 'E-mail',
          apiEnv: 'email_cob',
          apiRec: 'email_cob',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field['separador-' + contField] = { tipo: 'clear' }
        contField++

        self.formulario1.field.csc = {
          tipo: 'input',
          tamanho: 1,
          nome: 'CSC',
          apiEnv: 'csc_cod',
          apiRec: 'csc_cod',
          explica: { mensagem: 'O CSC - Código de Segurança do Contribuinte é um código de segurança alfanumérico de conhecimento apenas da SEFAZ e do contribuinte (sócio).<br/><br/>Este código é utilizado para gerar o código bidimensional, denominado "QR Code" da NFC-e. <br/><br/>(Para mais informações consulte o seu contador)' },
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field.csc_token = {
          tipo: 'input',
          tamanho: 2,
          nome: 'Token CSC',
          apiEnv: 'csc_token',
          apiRec: 'csc_token',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field['separador-' + contField] = { tipo: 'clear' }
        contField++

        self.formulario1.field.regime_trib = {
          tipo: 'select2',
          tamanho: 1,
          nome: 'Regime Tributário',
          apiEnv: 'rt_id',
          apiRec: 'rt_id',
          options: [
            { id: '1', nome: 'Simples Nacional' },
            { id: '2', nome: 'Simples Nacional – excesso de sublimite de receita bruta' },
            { id: '3', nome: 'Regime Normal' }
          ],
          keyValue: 'id',
          keyMostra: [ 'id', ' - ', 'nome' ],
          optionInicialNome: 'Selecione',
          optionInicialValue: '0',
          value: '0',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field.aliq_aplicavel = {
          tipo: 'input',
          tamanho: 2,
          nome: 'Alíquota Aplicável %',
          apiEnv: 'sn_ali_apl',
          apiRec: 'sn_ali_apl',
          mask: 'valor',
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field.tp_lucro = {
          tipo: 'select2',
          tamanho: 2,
          nome: 'Lucro',
          apiEnv: 'rt_3_opt',
          apiRec: 'rt_3_opt',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          options: [
            { id: 'p', nome: 'Presumido' },
            { id: 'r', nome: 'Real' }
          ],
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field['separador-' + contField] = { tipo: 'clear' }
        contField++

        self.formulario1.field.regime_especial = {
          tipo: 'select2',
          tamanho: 2,
          nome: 'Regime Especial de Tributação',
          apiEnv: 'ret_id',
          apiRec: 'ret_id',
          keyValue: 'id',
          keyMostra: [ 'id', ' - ', 'descricao' ],
          options: self.optionsRegimeEspTrib,
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field.incetivo_cultura = {
          tipo: 'select2',
          tamanho: 2,
          nome: 'Incentivador Cultural',
          apiEnv: 'inc_cul',
          apiRec: 'inc_cul',
          keyValue: 'id',
          keyMostra: [ 'id', ' - ', 'descricao' ],
          options: self.optionsIncentivador,
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field.optante_simples = {
          tipo: 'select2',
          tamanho: 2,
          nome: 'Optante pelo Simples Nacional',
          apiEnv: 'opt_sn',
          apiRec: 'opt_sn',
          keyValue: 'id',
          keyMostra: [ 'id', ' - ', 'descricao' ],
          options: self.optionsOptanteSimples,
          onChange: function (value, id) {
            self.onChangeValue('formulario1', id, value)
          }
        }
        self.formulario1.field['separador-' + contField] = { tipo: 'clear' }
        contField++

        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario1.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario1.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
          self.formulario2 = {
            status: '',
            id: 'form-config-cadastro-2',
            focus: '',
            field: {},
            idProduto: '',
            tabIndexFieldGeral: 10002
          }

          self.formulario2.field.cep = {
            tipo: 'input',
            tamanho: 2,
            nome: 'CEP',
            apiEnv: 'cep',
            apiRec: 'cep',
            mask: 'cep',
            maxLength: 8,
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field['separador-' + contField] = { tipo: 'clear', mostrar: true }
          contField++

          self.formulario2.field.estado = {
            tipo: 'select2',
            tamanho: 50,
            nome: 'Estado',
            apiEnv: 'id_estado',
            apiRec: 'id_estado',
            keyValue: 'uf',
            keyMostra: [ 'uf', ' - ', 'estado' ],
            options: self.optionsEstado,
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field.cidade = {
            tipo: 'select2',
            tamanho: 50,
            nome: 'Cidade',
            apiEnv: 'id_cidade',
            apiRec: 'id_cidade',
            keyValue: 'id',
            keyMostra: [ 'cidade' ],
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field['separador-' + contField] = { tipo: 'clear' }
          contField++

          self.formulario2.field.endereco = {
            tipo: 'input',
            tamanho: 1,
            nome: 'Endereço',
            apiEnv: 'endereco',
            apiRec: 'endereco',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field.numero = {
            tipo: 'input',
            tamanho: 2,
            nome: 'Numero',
            apiEnv: 'numero',
            apiRec: 'numero',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field['separador-' + contField] = { tipo: 'clear' }
          contField++

          self.formulario2.field.complemento = {
            tipo: 'input',
            tamanho: 50,
            nome: 'Complemento',
            apiEnv: 'complemento',
            apiRec: 'complemento',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field.bairro = {
            tipo: 'input',
            tamanho: 50,
            nome: 'Bairro',
            apiEnv: 'bairro',
            apiRec: 'bairro',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field['separador-' + contField] = { tipo: 'clear' }
          contField++

          self.formulario2.field.site = {
            tipo: 'input',
            tamanho: 50,
            nome: 'Site',
            apiEnv: 'site',
            apiRec: 'site',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field.observacao = {
            tipo: 'input',
            tamanho: 50,
            nome: 'Observação',
            apiEnv: 'obs',
            apiRec: 'obs',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field['separador-' + contField] = { tipo: 'clear' }
          contField++

          self.formulario2.field.rep_leg = {
            tipo: 'input',
            tamanho: 50,
            nome: 'Representante Legal',
            apiEnv: 'rep_leg',
            apiRec: 'rep_leg',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field.rep_cpf = {
            tipo: 'input',
            tamanho: 75,
            nome: 'Representante CPF',
            apiEnv: 'rep_cpf',
            apiRec: 'rep_cpf',
            mask: 'cpf',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field.rep_nas = {
            tipo: 'input',
            tamanho: 3,
            nome: 'Data de Nascimento',
            apiEnv: 'rep_nas',
            apiRec: 'rep_nas',
            mask: 'data',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
          self.formulario2.field['separador-' + contField] = { tipo: 'clear' }
          contField++

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario2.field, function (fields) {
            // SETA OS CAMPOS RECEBIDOS
            self.formulario2.field = fields

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // COMUNICA COM A API
            self.$store.state.comunicaAPI('/config/cadastro/get', 'GET', null, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS NO FORMULARIO
              self.$store.state.FUN_API_RET_SET_VALUE(self.formulario1, apiSuccess.data, function (form) {
                // SETA OS CAMPOS RECEBIDOS
                self.formulario1 = form

                // SETA OS VALORES RECEBIDOS NO FORMULARIO
                self.$store.state.FUN_API_RET_SET_VALUE(self.formulario2, apiSuccess.data, function (form) {
                  // SETA OS CAMPOS RECEBIDOS
                  self.formulario2 = form

                  // DEIXA APENAS OS NUMEROS NO CAMPO CEP
                  if (self.formulario2.field.hasOwnProperty('cep') && [ '', null, undefined ].indexOf(apiSuccess.data.cep) === -1) {
                    self.formulario2.field.cep.value = apiSuccess.data.cep.replace(/[^0-9]/g,'')
                    self.formulario2.field.cep.valueIni = apiSuccess.data.cep
                  }

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()

                  // CHAMA A FUNÇÃO QUE CRIA A TABELA DE CNAES
                  self.createTabelaCnae(apiSuccess.data.j_ramo_ids !== '' ? JSON.parse(apiSuccess.data.j_ramo_ids) : { aRamIds: [] }, apiSuccess.data.j_ati_ids !== '' ? JSON.parse(apiSuccess.data.j_ati_ids) : { aAtiIds: [] })
                }, [])
              }, [])
            }, function (apiError) {
              // SETA O STATUS
              self.statusGeral = apiError

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        })
      },
      createTabelaCnae: function (cnaes, atividade, buscaCNPJ = false) {
        var self = this

        self.tabelaCnae = {
          status: 'carregando',
          id: self.formulario1.id + '-tab-cnae',
          colqtip: {},
          colspan: {},
          api: {
            router: '',
            field: '',
            order: {},
            where: {},
            model: ''
          },
          mper: {
            field: false,
            rpp: false,
            order: false
          },
          coluna: [
            { mPer: 3, tipo: 'RF-Checkbox', chave: 'cnae' },
            { mPer: 3, chave: 'cnae', nome: 'CNAE' },
            { mPer: 3, chave: 'nome', nome: 'Descrição' },
            { mPer: 3, chave: 'rf-toggles', nome: 'Principal', click: false }
          ],
          linha: [],
          countAll: 0,
          acoes: {
            buttons: [ { status: '', id: self.formulario1.id + '-tab-cnae-bt-acoes-excluir', tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.onDeleteCnae } ],
            fields: {},
            btImprimir: false,
            btAtualizar: false
          },
          pagina: {},
          checkboxEditar: 'cnae',
          mostrar: true,
          mostraForm: false,
          autoComplite: {
            tamanho: 51,
            id: self.formulario1.id + '-auto-complite',
            status: '',
            tipo: 'auto-complite',
            nome: 'Digite sua pesquisa',
            apiRef: 'id_for',
            apiRec: 'id_for_nome',
            apiEnv: 'id_for',
            valueRef: '',
            value: '',

            keyMostra: [ 'cnae', ' - ', 'nome' ],
            field: { cnae: null, nome: null },
            router: '/referencia/cnae/get/',
            where: {},
            onChange: function (linha) {
              // SETA QUAIS SÃO OS CNAES SELECIONADOS
              self.selectedCnae.push(linha.cnae)

              linha['rf-toggles'] = [ {
                tamanho: 3,
                status: '',
                id: self.tabelaCnae.id + '--' + self.tabelaCnae.linha.length + '--rf-toggles--0',
                tipo: 'toggles',
                value: self.tabelaCnae.linha.length === 0,
                on: 'Sim',
                off: 'Não',
                width: '100px',
                onChange: function (value, id) {
                  // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
                  var index = id.split('--')

                  if (self.tabelaCnae.linha.hasOwnProperty(index[1])) {
                    for (var key in self.tabelaCnae.linha) {
                      self.tabelaCnae.linha[key][index[2]][index[3]].value = self.tabelaCnae.linha[key].cnae === self.tabelaCnae.linha[index[1]].cnae
                    }
                  }

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()
                }
              } ]

              // SETA A INFORMAÇÃO NOVA DO AUTOCOMPLITE
              self.tabelaCnae.autoComplite.where = { aAnd: [ { f: 'cnae', o: 'notIn', v: self.selectedCnae.join() }, { m: 'cnae', o: 's.ft', v: '' } ] }

              // ADICIONA A LINHA A TABELA
              self.tabelaCnae.linha.push(linha)

              // FECHA O FORMULARIO
              self.tabelaCnae.mostraForm = false

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }
        }

        self.tabelaCnae.button = {
          id: 'bt-adicionar-cnae',
          status: '',
          texto: 'Adicionar Cnae',
          class: 'btn btn-success btn-sm',
          onClick: function () {
            self.tabelaCnae.button.onAbrirFecharFormulario()

            self.onFocusCampo(self.formulario1.id + '-auto-complite')
          },
          onAbrirFecharFormulario: function () {
            self.tabelaCnae.mostraForm = !self.tabelaCnae.mostraForm
          }
        }

        var queryGet = { type: 'list', field: { cnae: null, nome: null }, where: { f: 'cnae', o: 'in', v: cnaes.aRamIds.join() }, limit: { row: 0, qty: 1000 } }

        // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
        self.$store.state.comunicaAPI('/referencia/cnae/get/', 'GET', queryGet, function (apiSuccess) {
          // SETA O COUNT ALL DA PESQUISA
          self.tabelaCnae.countAll = apiSuccess.countAll

          self.selectedCnae = []

          for (var key in apiSuccess.data) {
            var linha = apiSuccess.data[key]

            if (buscaCNPJ === true) {
              linha.rfClassTr = 'rf-field-destaque-busca_api'
              linha.rfClassTrFocus = 'rf-field-destaque-busca_api'
            }

            linha['rf-toggles'] = [ {
              tamanho: 3,
              status: '',
              id: self.tabelaCnae.id + '--' + key + '--rf-toggles--0',
              tipo: 'toggles',
              value: apiSuccess.data[key].cnae === cnaes.p,
              on: 'Sim',
              off: 'Não',
              width: '100px',
              onChange: function (value, id) {
                // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
                var index = id.split('--')

                if (self.tabelaCnae.linha.hasOwnProperty(index[1])) {
                  for (var key in self.tabelaCnae.linha) {
                    self.tabelaCnae.linha[key][index[2]][index[3]].value = self.tabelaCnae.linha[key].cnae === self.tabelaCnae.linha[index[1]].cnae

                    self.tabelaCnae.linha[key].rfClassTr = ''
                    self.tabelaCnae.linha[key].rfClassTrFocus = 'rf-background-tp-1'
                  }
                }

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              }
            } ]

            // SETA QUAIS SÃO OS CNAES SELECIONADOS
            self.selectedCnae.push(linha.cnae)

            // ADICIONA A LINHA A TABELA
            self.tabelaCnae.linha.push(linha)
          }

          // SETA A INFORMAÇÃO NOVA DO AUTOCOMPLITE
          self.tabelaCnae.autoComplite.where = { aAnd: [ { f: 'cnae', o: 'notIn', v: self.selectedCnae.join() }, { m: 'cnae', o: 's.ft', v: '' } ] }

          // SETA O STATUS DA TABELA
          self.tabelaCnae.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          if (buscaCNPJ === false) {
            // CHAMA A FUNÇÃO PARA BUSCAR AS ATIVIDADES
            self.createTabelaAtiv(cnaes, atividade)
          }
        }, function (apiError) {
          // SETA O STATUS
          self.statusGeral = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
        // if (cnaes.aRamIds.length >= 1) {
        // } else {
        //   // CHAMA A FUNÇÃO PARA BUSCAR AS ATIVIDADES
        //   self.createTabelaAtiv(cnaes, atividade)
        // }
      },
      createTabelaAtiv: function (cnaes, atividade) {
        var self = this

        if (atividade !== null) {
          self.tabelaAtiv = {
            status: 'carregando',
            id: self.formulario1.id + '-tab-ativ',
            colqtip: {},
            colspan: {},
            api: {
              router: '',
              field: '',
              order: {},
              where: {},
              model: ''
            },
            mper: {
              field: false,
              rpp: false,
              order: false
            },
            coluna: [
              { mPer: 3, tipo: 'RF-Checkbox', chave: 'id' },
              { mPer: 3, chave: 'id', nome: 'Código' },
              { mPer: 3, chave: 'id_cat_nome', nome: 'Categoria' },
              { mPer: 3, chave: 'nome', nome: 'Descrição' }
            ],
            linha: [],
            countAll: 0,
            acoes: {
              buttons: [ { status: '', id: self.formulario1.id + '-tab-ativ-bt-acoes-excluir', tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.onDeleteAtividade } ],
              // buttons: [ { status: '', id: self.formulario1.id + '-tab-cnae-bt-acoes-excluir', tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.onDeleteCnae } ],
              fields: {},
              btImprimir: false,
              btAtualizar: false
            },
            pagina: {},
            checkboxEditar: 'id',
            mostrar: true,
            mostraForm: false,
            autoComplite: {
              tamanho: 51,
              id: self.formulario1.id + '-auto-complite',
              status: '',
              tipo: 'auto-complite',
              nome: 'Digite sua pesquisa',
              apiRef: 'id_for',
              apiRec: 'id_for_nome',
              apiEnv: 'id_for',
              valueRef: '',
              value: '',

              keyMostra: [ 'id', ' - ', 'nome' ],
              field: { id: null, nome: null, id_cat: { j: { nome: null } } },
              router: '/referencia/ser-atividade/get/',
              where: {},
              onChange: function (linha) {
                // SETA QUAIS SÃO OS CNAES SELECIONADOS
                self.selectedAtiv.push(linha.id)

                // SETA A INFORMAÇÃO NOVA DO AUTOCOMPLITE
                self.tabelaAtiv.autoComplite.where = { aAnd: [ { f: 'id', o: 'notIn', v: self.selectedAtiv.join() }, { m: 'ser_atividade', o: 's.ft', v: '' } ] }

                // ADICIONA A LINHA A TABELA
                self.tabelaAtiv.linha.push(linha)

                // FECHA O FORMULARIO
                self.tabelaAtiv.mostraForm = false

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              }
            }
          }

          self.tabelaAtiv.button = {
            id: 'bt-adicionar-ativ',
            status: '',
            texto: 'Adicionar Atividade',
            class: 'btn btn-success btn-sm',
            onClick: function () {
              self.tabelaAtiv.button.onAbrirFecharFormulario()

              self.onFocusCampo(self.formulario1.id + '-auto-complite')
            },
            onAbrirFecharFormulario: function () {
              self.tabelaAtiv.mostraForm = !self.tabelaAtiv.mostraForm
            }
          }

          var queryGet = { type: 'list', field: { id: null, nome: null, id_cat: { j: { nome: null } } }, where: { f: 'id', o: 'in', v: atividade.aAtiIds.join() }, limit: { row: 0, qty: 1000 } }

          // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
          self.$store.state.comunicaAPI('/referencia/ser-atividade/get/', 'GET', queryGet, function (apiSuccess) {
            // SETA O COUNT ALL DA PESQUISA
            self.tabelaAtiv.countAll = apiSuccess.countAll

            self.selectedAtiv = []

            for (var key in apiSuccess.data) {
              var linha = apiSuccess.data[key]

              // SETA QUAIS SÃO OS CNAES SELECIONADOS
              self.selectedAtiv.push(linha.id)

              // ADICIONA A LINHA A TABELA
              self.tabelaAtiv.linha.push(linha)
            }

            // SETA A INFORMAÇÃO NOVA DO AUTOCOMPLITE
            self.tabelaAtiv.autoComplite.where = { aAnd: [ { f: 'id', o: 'notIn', v: self.selectedAtiv.join() }, { m: 'ser_atividade', o: 's.ft', v: '' } ] }

            // SETA O STATUS DA TABELA
            self.tabelaAtiv.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR A CIDADE
            self.buscaCidade(0, self.finalizarFormulario)
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        } else {
          // CHAMA A FUNÇÃO PARA BUSCAR A CIDADE
          self.buscaCidade(0, self.finalizarFormulario)
        }
      },
      onFocusCampo: function (idRef) {
        var self = this

        setTimeout(function () {
          if (self.$refs.hasOwnProperty(idRef)) {
            self.$refs[idRef].onFocusField()
          }
        }, 500)
      },
      onDeleteCnae: function () {
        if (window.confirm('Deseja realmente excluir o(s) registro(s) selecionados?')) {
          var self = this

          self.tabelaCnae.status = 'carregando'

          // REMOVE OS VALORES SELECIONADOS
          self.tabelaCnae.linha = self.tabelaCnae.linha.filter(item => self.checkbox.cnae.indexOf(item.cnae) === -1)

          // REMOVE A COR DE FUNDO DOS CAMPOS
          for (var key in self.tabelaCnae.linha) {
            self.tabelaCnae.linha[key].rfClassTr = ''
            self.tabelaCnae.linha[key].rfClassTrFocus = 'rf-background-tp-1'
          }

          // REMOVE OS VALORES SELECIONADOS
          self.selectedCnae = self.selectedCnae.filter(item => self.checkbox.cnae.indexOf(item) === -1)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            // SETA O NOVO WHERE DO AUTOCOMPLITE
            self.tabelaCnae.autoComplite.where = { aAnd: [ { f: 'cnae', o: 'notIn', v: self.selectedCnae.join() }, { m: 'cnae', o: 's.ft', v: '' } ] }

            // SETA O STATUS NOVAMENTE DA TABELA
            self.tabelaCnae.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, 300)
        }
      },
      onDeleteAtividade: function () {
        if (window.confirm('Deseja realmente excluir o(s) registro(s) selecionados?')) {
          var self = this

          self.tabelaAtiv.status = 'carregando'

          // REMOVE OS VALORES SELECIONADOS
          self.tabelaAtiv.linha = self.tabelaAtiv.linha.filter(item => self.checkbox.atividade.indexOf(item.id) === -1)

          // REMOVE OS VALORES SELECIONADOS
          self.selectedAtiv = self.selectedAtiv.filter(item => self.checkbox.atividade.indexOf(item) === -1)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            // SETA O NOVO WHERE DO AUTOCOMPLITE
            self.tabelaAtiv.autoComplite.where = { aAnd: [ { f: 'id', o: 'notIn', v: self.selectedAtiv.join() }, { m: 'ser_atividade', o: 's.ft', v: '' } ] }

            // SETA O STATUS NOVAMENTE DA TABELA
            self.tabelaAtiv.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, 300)
        }
      },
      finalizarFormulario: function () {
        var self = this

        // CHAMA A FUNÇÃO PRA VERIFICAR SE DEVE MOSTRAR ALGUNS CAMPOS
        self.verificaExibicaoCampo()

        if (self.cpntFields.length >= 1) {
          // FAZ UM FOR PARA REMOVER OS CAMPOS QUE NÃO FORAM INFORMADOS
          for (var key1 in self.formulario1.field) {
            if (self.formulario1.field[key1].hasOwnProperty('mostrar') && self.formulario1.field[key1].tipo !== 'clear') {
              if (self.cpntFields.indexOf(key1) === -1) {
                self.formulario1.field[key1].mostrar = false
              } else if (self.cpntFields.indexOf(key1) === -1) {
                self.formulario1.field[key1].mostrar = true
              }
            }
          }

          if (self.cpntFields.indexOf('tabelaCnae') === -1) {
            self.tabelaCnae.mostrar = false
          }

          if (self.cpntFields.indexOf('tabelaAtiv') === -1) {
            self.tabelaAtiv.mostrar = false
          }

          // FAZ UM FOR PARA REMOVER OS CAMPOS QUE NÃO FORAM INFORMADOS
          for (var key2 in self.formulario2.field) {
            if (self.formulario2.field[key2].hasOwnProperty('mostrar') && self.formulario2.field[key2].tipo !== 'clear') {
              if (self.cpntFields.indexOf(key2) === -1) {
                self.formulario2.field[key2].mostrar = false
              } else if (self.cpntFields.indexOf(key2) === -1) {
                self.formulario2.field[key2].mostrar = true
              }
            }
          }
        }

        // VERIFICA SE O CNPJ JÁ ESTA PREENCHIDO
        if (self.formulario1.field.cnpj.value !== '' && self.formulario1.field.cnpj.value !== null) {
          self.formulario1.field.cnpj.disabled = true
        }

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA O BOTÃO ENVIAR DO FORMULARIO
        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
        self.buttons.enviar = {
          id: self.formulario1.id + '-atualizar',
          status: '',
          texto: self.cpntNomeButton,
          tabIndex: 10003,
          class: [ 'btn', 'btn-primary' ],
          onClick: function () {
            self.enviarFormulario()
          }
        }

        // SETA O STATUS PARA O FORMULARIO
        self.statusGeral = ''

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        self.time = new Date().getTime()

        if (self.formulario1.field.cnpj === '') {
          self.focus = 'cnpj' // SETA O FOCUS NO PRIMEIRO CAMPO
        } else {
          self.focus = 'razao' // SETA O FOCUS NO PRIMEIRO CAMPO
        }

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        self.time = new Date().getTime()

        // VERIFICA SE O BOTÃO DE BUSCAR CPF DEVE SER APRESENTADO ATIVADO OU NÃO
        if (self.formulario1.field.hasOwnProperty('cnpj') && self.formulario1.field.hasOwnProperty('busca_api')) {
          var valorTeste = self.formulario1.field.cnpj.value.match(/[0-9]+/g)
          valorTeste = valorTeste !== null ? valorTeste.join('') : ''
          self.formulario1.field.busca_api.disabled = valorTeste.length !== 14
        }

        // CHAMA A FUNÇÃO PARA VERIFICAR OS CAMPOS FALTANTES
        self.meuCadastroValidacaoCampos()
      },
      verificaExibicaoCampo: function () {
        // VERIFICA SE TEM PACOTES 23 = NFC-E
        if (this.$store.state.token.clu_pcc.indexOf(23) === -1) {
          this.formulario1.field.csc.mostrar = false
          this.formulario1.field.csc_token.mostrar = false
        }

        // VERIFICA SE TEM PACOTES 25 = NFS-e SE NÃO TIVER OCULTA OS CAMPOS
        if (this.$store.state.token.clu_pcc.indexOf(25) === -1) {
          this.formulario1.field.regime_especial.mostrar = false
          this.formulario1.field.incetivo_cultura.mostrar = false
          this.formulario1.field.optante_simples.mostrar = false

          if (Object.keys(this.tabelaAtiv).length >= 1) {
            this.tabelaAtiv.mostrar = false
          }
        }

        // VERIFICA QUAL É O REGIME TRIBUTARIO DA EMPRESA
        if (this.formulario1.field['regime_trib'].value === '1' || this.formulario1.field['regime_trib'].value === '2') {
          this.formulario1.field.aliq_aplicavel.mostrar = true
          this.formulario1.field.tp_lucro.mostrar = false
        } else if (this.formulario1.field['regime_trib'].value.toString() === '3') {
          this.formulario1.field.aliq_aplicavel.mostrar = false
          this.formulario1.field.tp_lucro.mostrar = true
        } else {
          this.formulario1.field.aliq_aplicavel.mostrar = false
          this.formulario1.field.tp_lucro.mostrar = false
        }
      },
      onChangeValue: function (form, id, value) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this[form].id.length + 1), id.length)

        // SETA O VALOR RECEBIDO
        this[form].field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this[form].field[index].mensagem = ''
        this[form].field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index) {
          case 'cnpj':
            if (this.formulario1.field.hasOwnProperty('busca_api')) {
              var valorTeste = value.match(/[0-9]+/g)
              valorTeste = valorTeste !== null ? valorTeste.join('') : ''
              this.formulario1.field.busca_api.disabled = valorTeste.length !== 14
            }
            break

          case 'cep':
            this.buscaEnderecoViaCep()
            break

          case 'estado':
            // LIMPA O VALOR SELECIONADO
            this.formulario2.field['cidade'].value = ''

            // CHAMA A FUNÇÃO PARA BUSCAR AS CIDADES DO ESTADO SELECIONADO
            this.buscaCidade(0)
            break

          case 'regime_trib':
            this.verificaExibicaoCampo()
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      buscaCidade: function (count, callback = null) {
        var self = this

        // REMOVE O STATUS DO CAMPO
        self.formulario2.field.cidade.status = 'carregando'

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        self.time = new Date().getTime()

        // RESETA OS OPTIONS QUANDO INICIA A BUSCA
        if (count === 0) {
          self.formulario2.field.cidade.options = []
        }

        if (self.formulario2.field.estado.value !== '') {
          var queryGet = { type: 'list', field: { id: null, cidade: null }, where: { f: 'uf', o: '=', v: self.formulario2.field.estado.value }, limit: { row: count, qty: 1000 } }

          self.$store.state.comunicaAPI('/referencia/cep-cidade/get/', 'GET', queryGet, function (apiSuccess) {
            // // SETA OS OPTIONS DO CAMPO
            self.formulario2.field.cidade.options = self.formulario2.field.cidade.options.concat(apiSuccess.data)

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()

            if (count < apiSuccess.countAll) {
              self.buscaCidade(count + 1000, callback)
            } else {
              // REMOVE O STATUS DO CAMPO
              self.formulario2.field.cidade.status = ''

              // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()

              // EXECUTA A FUNÇÃO RECEBIDA
              if (callback !== null) {
                callback()
              }
            }
          }, function (apiError) {
            // SETA O STATUS PARA O FORMULARIO
            self.statusGeral = apiError

            // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        } else {
          // REMOVE O STATUS DO CAMPO
          self.formulario2.field.cidade.status = ''

          // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
          self.time = new Date().getTime()

          // EXECUTA A FUNÇÃO RECEBIDA
          if (callback !== null) {
            callback()
          }
        }
      },
      buscaEnderecoViaCep: function () {
        var self = this

        if (self.formulario2.field['cep'].value !== '' && /([0-9]{8})/g.exec(self.formulario2.field['cep'].value) !== null && self.formulario2.field['cep'].value.length === 8) {
          // CRIA A VARIAVEL QUERYGET
          // var queryGet = { type: 'list', field: { endereco: null, id_cidade: { j: { uf: null } }, id_bairro: { j: { bairro: null } } }, where: { f: 'cep', o: '=', v: self.formulario2.field['cep'].value }, limit: { row: 0, qty: 1 } }
          var queryGet = {}
          queryGet[self.formulario2.field['cep'].value] = null

          // COMUNICA COM A API
          self.$store.state.comunicaAPI('/referencia/buscar/cep/get/', 'GET', queryGet, function (apiSuccess) {
            if (apiSuccess.lot[0].code !== '200') {
              self.$store.state.msgWarn('CEP não encontrado. Por favor verifique e tente novamente.', 'warning')
            } else {
              // SETA O STATUS DO CAMPO
              self.formulario2.field['cidade'].status = 'carregando'

              // LIMPA OS OPTIONS DO CAMPO
              self.formulario2.field['cidade'].options = []

              // Salva os dados da cidade
              var dadosCidade = apiSuccess.lot[0].data

              // SETA OS DADOS RECEBIDOS DA API
              self.formulario2.field['estado'].value = dadosCidade.id_estado
              self.formulario2.field['estado'].mensagem = ''
              self.formulario2.field['estado'].mensagemTipo = ''

              // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR A CIDADE
              self.buscaCidade(0, function () {
                // SETA OS DADOS RECEBIDOS DA API
                self.formulario2.field['cidade'].value = dadosCidade.id_cidade
                self.formulario2.field['cidade'].mensagem = ''
                self.formulario2.field['cidade'].mensagemTipo = ''

                self.formulario2.field['endereco'].value = dadosCidade.end
                self.formulario2.field['endereco'].mensagem = ''
                self.formulario2.field['endereco'].mensagemTipo = ''

                self.formulario2.field['bairro'].value = dadosCidade.bairro
                self.formulario2.field['bairro'].mensagem = ''
                self.formulario2.field['bairro'].mensagemTipo = ''

                // ************************ IMPORTANTE ************************ //
                // 2019-10-21 09:48 - Raphael solicitou para remover essa opção de limpar o campo numero e complemento,
                // após identificar problema no cliente JULIO JFO que tava salvo no banco de dados o cep com - e ao limpar 
                // e colocar o cep correto o campo era limpado.
                // ************************ IMPORTANTE ************************ //
                // LIMPA OS CAMPOS QUE DEVEM SER PREENCHIDOS
                // self.formulario2.field['numero'].value = ''
                // self.formulario2.field['complemento'].value = ''

                // SETA O CAMPO QUE RECEBE O FOCUS
                self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario2', 'numero', false)

                // SETA O STATUS DO CAMPO
                self.formulario2.field['cidade'].status = ''

                // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
                self.time = new Date().getTime()
              })
            }

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        }
      },
      onCheckboxAtualizaCnae: function (coluna = null, checkbox = null) {
        if (coluna !== null && checkbox !== null) {
          var self = this
          var indexColuna = self.tabelaCnae.coluna.findIndex(item => item.chave === coluna)

          self.checkbox['cnae'] = checkbox.filter(item => item !== self.tabelaCnae.coluna[indexColuna].chave)
        }
      },
      onCheckboxAtualizaAtividade: function (coluna = null, checkbox = null) {
        if (coluna !== null && checkbox !== null) {
          var self = this
          var indexColuna = self.tabelaAtiv.coluna.findIndex(item => item.chave === coluna)

          self.checkbox['atividade'] = checkbox.filter(item => item !== self.tabelaAtiv.coluna[indexColuna].chave)
        }
      },
      enviarFormulario: function () {
        var self = this

        // SETA O STATUS DO BUTTON
        self.buttons.enviar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario1.field, {}, function (formData1) {
          self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario2.field, {}, function (formData2) {
            // AGRUPA OS VETORES
            var formData = Object.assign(formData1, formData2)

            // SETA OS CNAES SELECIONADOS
            formData['j_ramo_ids'] = { p: '', aRamIds: [] }
            for (var key1 in self.tabelaCnae.linha) {
              formData['j_ramo_ids'].aRamIds.push(self.tabelaCnae.linha[key1].cnae)

              if (self.tabelaCnae.linha[key1]['rf-toggles'][0].value === true) {
                formData['j_ramo_ids'].p = self.tabelaCnae.linha[key1].cnae
              }
            }
            formData['j_ramo_ids'] = JSON.stringify(formData['j_ramo_ids'])

            // SETA AS ATIVIDADES SELECIONADAS
            formData['j_ati_ids'] = { aAtiIds: [] }
            for (var key2 in self.tabelaAtiv.linha) {
              formData['j_ati_ids'].aAtiIds.push(self.tabelaAtiv.linha[key2].id)
            }
            formData['j_ati_ids'] = JSON.stringify(formData['j_ati_ids'])

            self.checkSitFiscalProduto(formData)
          }, false)
        }, false)
      },
      checkSitFiscalProduto: function (formData) {
        var self = this

        if (self.$store.state.licenca.rt_id === null || self.$store.state.licenca.rt_id === '' || self.$store.state.licenca.rt_id === '0') { // VERIFICA SE O REGIME TRIB É NULL OU EM BRANCO
          self.checkSitFiscalServico(formData)
        } else if (!formData.hasOwnProperty('rt_id') || formData['rt_id'] === self.$store.state.licenca.rt_id) { // OU VERIFICA SE O VALOR É IGUAL AO QUE JA ESTA SALVO
          self.checkSitFiscalServico(formData)
        } else if (formData['rt_id'] !== self.$store.state.licenca.rt_id) {
          // OU SE FOR DIFERENTE FAZ A PERGUNTA PARA O USUARIO SE DESEJA ATUALIZAR MESMO O REGIME TRIBUTARIO

          self.$store.state.comunicaAPI('/produto/sit-fiscal2/get', 'POST', { type: 'list', return: 'countAll', where: { f: 'status', o: '=', v: '1' } }, function (apiSuccess) {
            var mensagemConfirma = '*** LEIA - AVISO IMPORTANTE - PRODUTOS ***\n\nVocê esta alterando o Regime Tributário. Isto ocasionará a Perda de TODAS as situações fiscais (' + apiSuccess.countAll + ') dos Produtos! Após esta confirmação será necessário o recadastramento de todos os casos em Menu -> Produtos -> Situações Fiscais\n\nSó será possível continuar a emissão dos documentos fiscais após esta re-configuração.\n\nDeseja prosseguir?'

            if (apiSuccess.countAll === '0') {
              self.checkSitFiscalServico(formData)
            } else if (confirm(mensagemConfirma)) {
              self.checkSitFiscalServico(formData)
            } else {
              // REMOVE O STATUS DE CARREGANDO E LIBERA O FORMULARIO
              self.buttons.enviar.status = ''

              // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
              self.time = new Date().getTime()
            }
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        } else {
          self.buttons.enviar.status = { aCod: '500', aErr: 'WEB [500]: Erro ao checar situação fiscal dos produtos.' }

          // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
          self.time = new Date().getTime()
        }
      },
      checkSitFiscalServico: function (formData) {
        var self = this
        var arraySimples = [ '1', '3', '7', '8' ]

        if (self.$store.state.licenca.OptanteSimples === null || self.$store.state.licenca.OptanteSimples === '') {
          self.onAtualizarCadastro(formData)
        } else if (formData.hasOwnProperty('opt_sn') && arraySimples.indexOf(self.$store.state.licenca.OptanteSimples) === -1 && arraySimples.indexOf(formData.opt_sn) !== -1) {
          self.$store.state.comunicaAPI('/servico/cat-sit-fiscal/get/', 'GET', { type: 'list', limit: { row: 0, qty: 1000 }, field: { id_ser_cat: null } }, function (apiSuccess) {
            var mensagemConfirma = '*** LEIA - AVISO IMPORTANTE - SERVIÇOS ***\n\nVocê esta alterando o Regime Tributário. Isto ocasionará a Perda de TODAS as situações fiscais (' + apiSuccess.countAll + ') dos Serviços! Após esta confirmação será necessário o recadastramento de todas as categorias de serviço.\n\nDeseja prosseguir?'

            if (Number(apiSuccess.countAll) <= 0) {
              self.onAtualizarCadastro(formData)
            } else if (confirm(mensagemConfirma)) {
              self.onAtualizarCadastro(formData)
            } else {
              // REMOVE O STATUS DE CARREGANDO E LIBERA O FORMULARIO
              self.buttons.enviar.status = ''

              // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
              self.time = new Date().getTime()
            }
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        } else {
          self.onAtualizarCadastro(formData)
        }
      },
      onAtualizarCadastro: function (formData) {
        var self = this

        // COMUNICA COM A API
        self.$store.state.comunicaAPI('/config/cadastro', 'PUT', formData, function (apiSuccess) {
          // SETA A MASCARA DE CARREGANDO
          if (self.cpntFields.length === 0) {
            self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }])
          }

          SESSAO_ATUALIZAR_VUEX('licenca', function () {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              if (self.cpntFields.length === 0) {
                // SETA O STATUS DO BUTTON
                self.buttons.enviar.status = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                // SETA A MASCARA DE CARREGANDO
                self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
              } else {
                self.cpntFecharCadastro('enviar')
              }
            })
          })
        }, function (apiError) {
          // SETA O STATUS
          self.statusGeral = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario1', apiValid, apiStatus, self.formulario1.field, false, function (field, focus, apiValid) {
            // SETA OS CAMPOS COM OS ERROS
            self.formulario1.field = field

            // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()

            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario2', apiValid, apiStatus, self.formulario2.field, true, function (field) {
              // SETA OS CAMPOS COM OS ERROS
              self.formulario2.field = field

              // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()

              // SETA O STATUS DO BUTTON
              self.buttons.enviar.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        })
      },
      meuCadastroOnAtualizaValor: function (campo, operacao, valor, valorExtra = null) {
        var form = null

        if (this.formulario1.field.hasOwnProperty(campo) && this.formulario1.field[campo].mostrar === true) {
          form = 'formulario1'
        } else if (this.formulario2.field.hasOwnProperty(campo) && this.formulario2.field[campo].mostrar === true) {
          form = 'formulario2'
        }

        if (form !== null) {
          switch (operacao) {
            case '0':
              valor = null
              break

            case '1':
              if (this[form].field[campo].value.trim() !== '' && valor.trim() !== '') {
                if ([ 'email' ].indexOf(campo) !== -1) {
                  valor = this[form].field[campo].value.trim() + ';' + valor.trim()
                } else {
                  valor = this[form].field[campo].value.trim() + ' ' + valor.trim()
                }
              } else if (this[form].field[campo].value.trim() !== '') {
                valor = this[form].field[campo].value.trim()
              } else if (valor.trim() !== '') {
                valor = valor.trim()
              }
              break
          }

          if (valor !== null) {
            switch (campo) {
              case 'estado':
                var self = this

                // LIMPA AS MENSAGENS DE VALIDAÇÃO
                self[form].field['estado'].mensagem = ''
                self[form].field['estado'].mensagemTipo = ''

                // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
                self.time = new Date().getTime()

                if (self[form].field['estado'].value === valor) {
                  // SETA A COR AMARELA NOS CAMPOS ALTERADOS
                  if (self[form].field['cidade'].value !== valorExtra) {
                    self[form].field['cidade'].classDivField = 'rf-field-destaque-busca_api'
                  }

                  // SETA OS DADOS RECEBIDOS DA API
                  self[form].field['cidade'].value = valorExtra

                  // LIMPA AS MENSAGENS DE VALIDAÇÃO
                  self[form].field['cidade'].mensagem = ''
                  self[form].field['cidade'].mensagemTipo = ''
                } else {
                  // SETA A COR AMARELA NOS CAMPOS ALTERADOS
                  self[form].field['estado'].classDivField = 'rf-field-destaque-busca_api'

                  // SETA O STATUS DO CAMPO
                  self[form].field['cidade'].status = 'carregando'

                  // LIMPA OS OPTIONS DO CAMPO
                  self[form].field['cidade'].options = []

                  // SETA OS DADOS RECEBIDOS DA API
                  self[form].field['estado'].value = valor

                  // CHAMA A FUNÇÃO PARA BUSCAR A CIDADE
                  self.buscaCidade(0, function () {
                    // SETA A COR AMARELA NOS CAMPOS ALTERADOS
                    if (self[form].field['cidade'].value !== valorExtra) {
                      self[form].field['cidade'].classDivField = 'rf-field-destaque-busca_api'
                    }

                    // SETA OS DADOS RECEBIDOS DA API
                    self[form].field['cidade'].value = valorExtra

                    // LIMPA AS MENSAGENS DE VALIDAÇÃO
                    self[form].field['cidade'].mensagem = ''
                    self[form].field['cidade'].mensagemTipo = ''
                  })
                }

                valor = null
                break

              case 'rep_leg':
                valor = JSON.parse(valor)
                if (valor.length >= 1) {
                  valor = valor[0].nome.trim()
                } else {
                  valor = null
                }
                break

              case 'telefone':
                valor = valor.split('/')
                if (valor.length >= 1) {
                  valor = valor[0]
                } else {
                  valor = ''
                }

                valor.trim()
                valor = valor.replace(/\D/g, '')
                valor = valor.replace(/^(\d{2})(\d)/g, '($1)$2')
                valor = valor.replace(/(\d)(\d{4})$/, '$1-$2')
                valor.trim()
                break

              case 'ie':
                if ([ '1', '2' ].indexOf(operacao) === -1) {
                  valor = operacao
                }

                if (typeof valor === 'object') {
                  if (valor.length === 0) {
                    valor = ''
                  } else if (valor.length === 1) {
                    valor = valor[0]
                  } else {
                    valor = operacao
                  }
                }

                if ([ '', null, undefined ].indexOf(valor) === -1) {
                  // CARREGA OS DADOS DO JSON RECEBIDO
                  if ([ '', null ].indexOf(this.buscaCNPJ.dados.j_ie_regime) === -1 && typeof this.buscaCNPJ.dados.j_ie_regime === 'string') {
                    this.buscaCNPJ.dados.j_ie_regime = JSON.parse(this.buscaCNPJ.dados.j_ie_regime)
                  }

                  var cadicms = this.buscaCNPJ.dados.j_ie_regime.filter(item => item.IE === valor)
                  cadicms = cadicms.length === 1 ? cadicms[0] : {}

                  if (Object.keys(cadicms).length >= 1) {
                    this.meuCadastroOnAtualizaValor('regime_trib', '2', [ '1', 1, true, 'true' ].indexOf(cadicms.SimplesNacional) !== -1)
                  }
                }
                break

              case 'regime_trib':
                // SETA O VALOR RECEBIDO NO CAMPO
                this[form].field.regime_trib.value = valor === true ? '1' : '3'
                this[form].field.optante_simples.value = valor === true ? '1' : '2'
                // Optante pelo Simples Naciona

                // SETA A COR AMARELA NOS CAMPOS ALTERADOS
                this[form].field.regime_trib.classDivField = 'rf-field-destaque-busca_api'
                this[form].field.optante_simples.classDivField = 'rf-field-destaque-busca_api'

                // CHAMA A FUNÇÃO PARA VER QUAL CAMPO PODE SER MOSTRADO OU NÃO
                this.verificaExibicaoCampo()

                // LIMPA OS DADOS PARA NÃO ENTRAR NOS CAMPOS ABAIXO
                valor = null
                break
            }

            // VERIFICA SE O VALOR RECEBIDO EXISTE
            if (valor === undefined) {
              valor = null
            }

            if (valor !== null && this[form].field.hasOwnProperty(campo) && this[form].field[campo].mostrar === true) {
              // SETA O VALOR RECEBIDO
              this[form].field[campo].value = (typeof valor !== 'boolean' ? valor.trim() : valor)

              // SETA A COR AMARELA NOS CAMPOS ALTERADOS
              this[form].field[campo].classDivField = 'rf-field-destaque-busca_api'
            }

            if (this[form].field.hasOwnProperty(campo) && this[form].field[campo].mostrar === true) {
              // LIMPA AS MENSAGENS DE VALIDAÇÃO
              this[form].field[campo].mensagem = ''
              this[form].field[campo].mensagemTipo = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }
        } else if (campo === 'cnae') {
          if (operacao === '2') {
            this.createTabelaCnae(JSON.parse(valor), null, true)
          }
        } else {
          this.$store.state.msgWarn('Campo (' + campo + ') não encontrado para atualização', 'danger')
        }
      },
      meuCadastroOnBuscaCNPJ: function () {
        var self = this

        if (self.formulario1.field.cnpj.value !== '') {
          // SETA O STATUS NO BUTTON
          self.formulario1.field.busca_api.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // MONTA O QUERY GET
          var queryGet = {}

          // MONTA O VETOR DE DADOS
          queryGet[self.formulario1.field.cnpj.value.replace(/\D/g, '')] = null

          // REALIZA A BUSCA DOS DADOS NA API
          self.$store.state.comunicaAPI('/referencia/buscar/cnpj/get/', 'GET', queryGet, function (apiSuccess) {
            if (apiSuccess.lot[0].code === '200') {
              // PEGA O RETORNO RECEBIDO DA API
              var retorno = apiSuccess.lot[0]

              // SETA O STATUS NO BUTTON
              self.formulario1.field.busca_api.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA ABRIR A TELA DE CONFERENCIA
              self.meuCadastroCheckCampoAtualiza(retorno.data)
            } else {
              // SETA A MENSAGEM RECEBIDA
              self.$store.state.msgWarn('API [' + apiSuccess.lot[0].code + ']: ' + apiSuccess.lot[0].message, apiSuccess.lot[0].code === '406' ? 'warning' : 'danger')

              // SETA O STATUS NO BUTTON
              self.formulario1.field.busca_api.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        }
      },
      meuCadastroCheckCampoAtualiza: function (dados) {
        var self = this

        // LIMPA OS DADOS DA CHAVE
        self.buscaCNPJ = {}

        // SETA OS DADOS RECEBIDOS
        self.buscaCNPJ.dados = dados

        // SETA OS DADOS DOS FORMULARIOS
        self.buscaCNPJ.dadosForm = Object.assign(JSON.parse(JSON.stringify(self.formulario1.field)), JSON.parse(JSON.stringify(self.formulario2.field)))

        // SETA OS CNAES SELECIONADOS
        var objetoCnae = { p: '', aRamIds: [] }
        for (var key1 in self.tabelaCnae.linha) {
          objetoCnae.aRamIds.push(self.tabelaCnae.linha[key1].cnae)

          if (self.tabelaCnae.linha[key1]['rf-toggles'][0].value === true) {
            objetoCnae.p = self.tabelaCnae.linha[key1].cnae
          }
        }
        objetoCnae = { cnae: objetoCnae }
        self.buscaCNPJ.dadosForm = Object.assign(self.buscaCNPJ.dadosForm, objetoCnae)

        // SETA OS CAMPOS QUE SERÁ APRESENTADO
        self.buscaCNPJ.campos = [
          {
            nome: 'Nome Contratual',
            keyForm: 'razao',
            keyApi: 'nome'
          },
          // {
          //   nome: 'Nome Fantasia',
          //   keyForm: 'nome_fan',
          //   keyApi: 'fantasia'
          // },
          // {
          //   nome: 'Telefone Comercial',
          //   keyForm: 'tel_com',
          //   keyApi: 'telefone',
          //   converteApi: { tipo: 'divide', posicao: 0 },
          //   acao: { 0: false, 1: true, 2: false }
          // },
          {
            nome: 'Inscrição Estadual',
            keyForm: 'ie',
            keyApi: 'j_ie_regime',
            converteApi: { tipo: 'radio' },
            acao: { 0: false, 1: true, 2: false }
          },
          {
            nome: 'Telefone',
            keyForm: 'telefone',
            keyApi: 'telefone',
            converteApi: { tipo: 'divide', posicao: 0 },
            acao: { 0: false, 1: true, 2: false }
          },
          // {
          //   nome: 'Telefone',
          //   keyForm: 'telefone',
          //   keyApi: 'telefone'
          //   // converteApi: { tipo: 'divide', posicao: 1 },
          //   // acao: { 0: false, 1: true, 2: false }
          // },
          // {
          //   nome: 'Contato',
          //   keyForm: 'contato',
          //   keyApi: 'j_quadro_socios',
          //   converteApi: { tipo: 'socio' }
          // },
          {
            nome: 'E-mail',
            keyForm: 'email',
            keyApi: 'email'
          },
          {
            nome: 'CEP',
            keyForm: 'cep',
            keyApi: 'cep',
            acao: { 0: false, 1: true, 2: false }
          },
          {
            nome: 'UF',
            keyForm: 'estado',
            keyApi: 'id_estado',
            acao: { 0: false, 1: true, 2: false }
          },
          {
            nome: 'Cidade',
            keyForm: 'cidade',
            converteForm: { tipo: 'cidade', keyValue: 'id', keyMostra: 'cidade' },
            keyApi: 'cidade',
            acao: { 0: false, 1: true, 2: false }
          },
          {
            nome: 'Endereço',
            keyForm: 'endereco',
            keyApi: 'end'
          },
          {
            nome: 'Número',
            keyForm: 'numero',
            keyApi: 'num'
          },
          {
            nome: 'Complemento',
            keyForm: 'complemento',
            keyApi: 'comp'
          },
          {
            nome: 'Bairro',
            keyForm: 'bairro',
            keyApi: 'bairro'
          },
          {
            nome: 'Representante Legal',
            keyForm: 'rep_leg',
            keyApi: 'j_quadro_socios',
            converteApi: { tipo: 'socio' }
          },
          {
            nome: 'CNAE',
            keyForm: 'cnae',
            converteForm: { tipo: 'cnae' },
            keyApi: 'j_ramo_ids',
            converteApi: { tipo: 'cnae' },
            acao: { 0: false, 1: true, 2: false }
          }
        ]

        self.buscaCNPJ.fecharFormulario = function (atualizar, campos = {}) {
          if (atualizar === true && Object.keys(campos).length >= 1) {
            if (campos.hasOwnProperty('cidade') && !campos.hasOwnProperty('estado')) {
              campos.estado = campos.cidade
            }

            for (var key in campos) {
              // BUSCA QUAL É O CAMPO QUE DEVE ATUALIZAR
              var campo = self.buscaCNPJ.campos.filter(item => item.keyForm === key)[0]

              if (campo.keyForm === 'estado') {
                self.meuCadastroOnAtualizaValor('estado', campos[key], dados.id_estado, dados.id_cidade)
              } else if (campo.keyForm !== 'cidade') {
                // CHAMA A FUNÇÃO PARA ATUALIZAR O CAMPO
                self.meuCadastroOnAtualizaValor(campo.keyForm, campos[key], dados[campo.keyApi])
              }
            }

            // APRESENTA MENSAGEM DE ERRO NOVAMENTE PARA O CLIENTE
            if (dados.situacao !== 'ATIVA') {
              self.$store.state.msgWarn('Informação importante: Em nosso cadastro este CNPJ consta como ' + dados.situacao + '.', 'warning')
            }

            // LIMPA OS DADOS DA CHAVE
            self.buscaCNPJ = {}

            // APRESENTA A MENSAGEM PARA O CLIENTE
            self.$store.state.msgWarn('A solicitação foi processada com sucesso.', 'success')
          } else {
            self.buscaCNPJ = {} // LIMPA OS DADOS DA CHAVE
          }
        }
      },
      meuCadastroValidacaoCampos: function () {
        var self = this

        if (self.cpntFields.length >= 1) {
          setTimeout(function () {
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
  
            if (Object.keys(self.cpntApiValid).length >= 1) {
              self.$store.state.FUN_API_RET_VALIDA(self, 'formulario1', self.cpntApiValid, 400, self.formulario1.field, false, function (field, focus, apiValid) {
                // SETA OS CAMPOS COM OS ERROS
                self.formulario1.field = field

                // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
                self.time = new Date().getTime()

                self.$store.state.FUN_API_RET_VALIDA(self, 'formulario2', apiValid, 400, self.formulario2.field, true, function (field) {
                  // SETA OS CAMPOS COM OS ERROS
                  self.formulario2.field = field
                  
                  // SETA O STATUS DO BUTTON
                  self.buttons.enviar.status = ''

                  // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
                  self.time = new Date().getTime()
                })
              })
            }
          }, 500)
        }
      }
    },
    watch: {
      cpntApiValid: function () {
        this.meuCadastroValidacaoCampos()
      }
    }
  }
</script>
